import request from "../util/request";
import {APP_KEY,API_URL,WEB_CODE} from "../util/constants";

export function getHzDzRankingRequest(studentcode, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("studentcode", studentcode);
    formData.append("caozuo", "hd_dz_pm");
    formData.append("class_code", sessionStorage.getItem('classcode'));

    return fetch(API_URL+'/jzbaogao/getStuInfo',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);
    });
}

export function getHzDzRankingXueqiRequest(studentcode, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("studentcode", studentcode);
    formData.append("caozuo", "hd_dz_pm");
    formData.append("class_code", sessionStorage.getItem('classcode'));

    return fetch(API_URL+'/XueqiBaogao/index',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);
    });
}

export function getHzListRequest(studentcode, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("studentcode", studentcode);

    return fetch(API_URL+'/jzbaogao/getbg2',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);
    });
}
export function getHzListXueqiRequest(studentcode, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "getbg2");
    formData.append("studentcode", studentcode);

    return fetch(API_URL+'/XueqiBaogao/index',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);
    });
}

export function getDzListRequest(studentcode, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("studentcode", studentcode);

    return fetch(API_URL+'/jzbaogao/getbg3',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);
    });
}

export function getDzListXueqiRequest(studentcode, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "getbg3");
    formData.append("studentcode", studentcode);

    return fetch(API_URL+'/XueqiBaogao/index',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);
    });
}

//学期表现曲线报告页
export function getHzForTermListRequest(studentcode, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("studentcode", studentcode);
    formData.append("caozuo", 'xueqi_quxian');
    formData.append("class_code", sessionStorage.getItem('classcode'));

    return fetch(API_URL+'/jzbaogao/getStuInfo',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);
    });
}
export function getHzForTermListXueqiRequest(studentcode, callback) {
    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("studentcode", studentcode);
    formData.append("caozuo", 'xueqi_quxian');
    formData.append("class_code", sessionStorage.getItem('classcode'));

    return fetch(API_URL+'/XueqiBaogao/index',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);
    });
}
//荣誉榜
export function getHzDzHonorListRequest(studentcode, callback) {
    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("studentcode", studentcode);

    return fetch(API_URL+'/jzbaogao/getbg5',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);
    });
}



